import { ImageOff } from "lucide-react";
import { useEffect, useState } from "react";
import { defaultMenuImage } from "../data/menuImages";

export const MenuItemImage = ({ src, alt, className = "", fallbackClassName = "" }) => {
  const [failed, setFailed] = useState(false);
  const configuredUrl = typeof src === "string" ? src.trim() : "";
  const fallbackUrl = defaultMenuImage(alt);
  const [imageUrl, setImageUrl] = useState(configuredUrl || fallbackUrl);

  useEffect(() => {
    setFailed(false);
    setImageUrl(configuredUrl || fallbackUrl);
  }, [configuredUrl, fallbackUrl]);

  if (imageUrl && !failed) {
    return (
      <img
        src={imageUrl}
        alt={alt}
        loading="lazy"
        referrerPolicy="no-referrer"
        onError={() => {
          if (imageUrl !== fallbackUrl) setImageUrl(fallbackUrl);
          else setFailed(true);
        }}
        className={"shrink-0 object-cover " + className}
      />
    );
  }

  return (
    <div
      role="img"
      aria-label={alt + " image unavailable"}
      className={"flex shrink-0 flex-col items-center justify-center bg-brand-beige text-brand-brown/45 " + (fallbackClassName || className)}
    >
      <ImageOff className="h-5 w-5" />
      <span className="mt-1 text-[8px] font-bold uppercase tracking-wider">Dish</span>
    </div>
  );
};
